import { getUrlParameterByName } from '../modules/utils'
// Check for UTM Variables and update the Hidden form Fields if they exist
// Example: silverchef.com.au?utm_source=newsletter&utm_medium=email&utm_campaign=scp_campaign&utm_term=rental-products
export default function CheckForUTMvariables() {
  // Object Details are
  // - Key => the url Query Parameter
  // - Value => DOM Selector
  const parformFormSelectors = {
    utm_source: `utm_source`,
    utm_medium: `utm_medium`,
    utm_campaign: `utm_campaign`,
    utm_content: `utm_content`,
    utm_term: `utm_term`
  }
  const salesForceFormSelectors = {
    utm_source: `utm_source__c`,
    utm_medium: `utm_medium__c`,
    utm_campaign: `utm_campaign__c`,
    utm_content: `utm_content__c`,
    utm_term: `utm_term__c`
  }

  populateHiddenFields(parformFormSelectors)
  populateHiddenFields(salesForceFormSelectors)
}
function populateHiddenFields(fieldObject) {
  for (const [key, value] of Object.entries(fieldObject)) {
    const param = getUrlParameterByName(key)
    const hiddenField = document.getElementsByName(value)
    hiddenField.forEach(field => pushUTMvalue(field, param))
  }
}
function pushUTMvalue(field, value) {
  if (field && value) {
    field.value = value
  }
}
